import * as React from 'react'

const SvgMigrateIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 1.25H3.75c-.69 0-1.25.56-1.25 1.25V5c0 .69.56 1.25 1.25 1.25h5.625v3.856L7.756 8.494l-.881.881L10 12.5l3.125-3.125-.881-.881-1.619 1.612V6.25h5.625c.69 0 1.25-.56 1.25-1.25V2.5c0-.69-.56-1.25-1.25-1.25zM3.75 2.5h2.5V5h-2.5V2.5zM16.25 5H7.5V2.5h8.75V5zm0 8.75H3.75c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V15c0-.69-.56-1.25-1.25-1.25zM3.75 15h8.75v2.5H3.75V15zm12.5 2.5h-2.5V15h2.5v2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgMigrateIcon
